import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'
import BaixarDocumentoAtaInput from '@/core/apiclient/ata/documentos-ata/models/BaixarDocumentoAtaInput'

const URL_PATH = 'api/atas'

class DocumentosAtaApiClient {
	async buscarListagem(filtro, paginacao, idDaAta, modalPenalidade) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idDaAta}/documentos`,
			filters: { ...filtro, ...modalPenalidade },
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()
		return await axios.get(url)
	}

	async excluir(documento) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/documentos/${documento.idDocumentoAta}`,
			filters: documento.filtros,
		}).build()

		return await axios.delete(url)
	}

	async baixar(documento) {
		const baixarDocumentoAtaInput = new BaixarDocumentoAtaInput(documento)

		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/documentos/${baixarDocumentoAtaInput.idDocumentoAta}/baixar`,
			filters: {
				tipoRegistroDocumento: baixarDocumentoAtaInput.tipoRegistroDocumento,
				situacaoDocumento: baixarDocumentoAtaInput.situacao,
			},
		}).build()

		return await axios.get(url, {
			responseType: 'arraybuffer',
		})
	}

	async enviarPncp(documentoId, ataId) {
		return await axios.post(`${URL_PATH}/${ataId}/contratacao-publica/documento/lote`, {
			idsDocumentosAtaRegistroPreco: [documentoId],
		})
	}

	async excluirPncp(documentoId) {
		return await axios.delete(`${URL_PATH}/contratacao-publica/documento/${documentoId}`)
	}

	async enviarFornecedor({ idDocumento, emailFornecedor }) {
		await axios.post(`${URL_PATH}/documentos/${idDocumento}/enviar-fornecedor`, { emailFornecedor })
	}

	async inserirDocumentoAta(obj) {
		return await axios.post(`${URL_PATH}/documentos`, obj)
	}

	async sincronizarAreaPublica({ id, isDocPublico }) {
		return await axios.put(`${URL_PATH}/documentos/sincronizar-area-publica`, {
			idDocumento: id,
			exibirAreaPublica: !isDocPublico,
		})
	}

	async sincronizarAreaPublicaEmLote(obj) {
		return await axios.put(`${URL_PATH}/documentos/sincronizar-area-publica/lote`, obj)
	}
}

export default new DocumentosAtaApiClient()
